<div class="flex-container">
  @if (canEdit) {
    <div class="ml-auto">
      <button type="button" mat-raised-button (click)="onAddTimeBasedRouteClick()">Add Rule</button>
    </div>
  }
</div>

<ul cdkDropList class="route-item-list" (cdkDropListDropped)="drop($event)">
  @for (timeBasedRouteItem of extensionTimeBasedRouteItems; track timeBasedRouteItem; let timeBasedRouteArrayIndex = $index) {
    <li cdkDrag>
      @if (!timeBasedRouteItem.isDeleted) {
        <div class="route-item">
          <mat-icon class="draggable" aria-label="reorder drag handle" cdkDragHandle>drag_indicator</mat-icon>
          <div class="route-description-wrapper">
            @if (!timeBasedRouteItem.comment) {
              <div class="route-title"
                >Route To
                {{ timeBasedRouteItem?.routeExtension?.number ?? timeBasedRouteItem?.routeExtensionNullAction ?? '' }}
              </div>
            }
            @if (timeBasedRouteItem.comment) {
              <div class="route-title">
                {{ timeBasedRouteItem.comment }} : Route To
                {{
                timeBasedRouteItem?.routeExtension?.number > 0
                ? timeBasedRouteItem?.routeExtension?.number
                : timeBasedRouteItem?.routeExtensionNullAction ?? ''
                }}
              </div>
            }
            <div class="route-description">
              <span
                ><strong> {{ timeBasedRouteItem.startDate ? 'Start Date:' : '' }}</strong>
                {{ timeBasedRouteItem.startDate ? (timeBasedRouteItem.startDate | date : 'yyyy-MM-dd' : 'UTC') : '' }}
                <strong>{{ timeBasedRouteItem.endDate ? 'End Date:' : '' }}</strong>
                {{ timeBasedRouteItem.endDate ? (timeBasedRouteItem.endDate | date : 'yyyy-MM-dd' : 'UTC') : '' }}
                <strong>{{ timeBasedRouteItem.startTime ? 'Start Time:' : '' }}</strong>
                {{
                timeBasedRouteItem.startTime
                ? (timeBasedRouteItem.startTime | date : 'hh:mm aa&nbsp;&nbsp;' : 'UTC')
                : ''
                }}
                <strong>{{ timeBasedRouteItem.endTime ? 'End Time:' : '' }}</strong>
                {{
                timeBasedRouteItem.endTime
                ? (timeBasedRouteItem.endTime | date : 'hh:mm aa&nbsp;&nbsp;' : 'UTC')
                : ''
                }}
                @if (timeBasedRouteItem.activeDaysString) {
                  <strong>Days of Week:</strong>
                }
                {{ timeBasedRouteItem.activeDaysString }}
              </span>
            </div>
          </div>
          <div class="route-actions">
            <button
              type="button"
              aria-label="Time Based Route Actions"
              matTooltip="More Actions"
              mat-icon-button
              [matMenuTriggerFor]="routeListItemMenu"
              [matMenuTriggerData]="{ $implicit: timeBasedRouteItem, index: timeBasedRouteArrayIndex }"
              [disabled]="disabled"
              id="time-based-route-list-option-menu-button-{{ timeBasedRouteArrayIndex }}"
              >
              <mat-icon> more_vert </mat-icon>
            </button>
            <mat-menu #routeListItemMenu="matMenu">
              <input type="hidden" />
              @if (canEdit) {
                <button
                  mat-menu-item
                  type="button"
                  id="menu-edit"
                  (click)="onEditTimeBasedRouteClick(timeBasedRouteArrayIndex)"
                  >
                  Edit
                </button>
              }
              @if (canEdit) {
                <button
                  mat-menu-item
                  type="button"
                  id="menu-delete"
                  (click)="onDeleteClick(timeBasedRouteArrayIndex)"
                  >
                  Delete
                </button>
              }
            </mat-menu>
          </div>
        </div>
      }
    </li>
  }
  @if (!extensionTimeBasedRouteItems || extensionTimeBasedRouteItems.length === 0) {
    <span>No Rules Set</span>
  }
</ul>
